import { trackConversion } from '../../api/tracking/trackingAPI';
import { extractCampaignParams } from './trackingUtils';

/**
 * Helper function to track conversions
 * @param {string} purpose - Purpose of conversion (e.g., "create account", "create filing")
 * @param {string} type - Type of conversion ("CLK", "UNK")
 * @param {string} url - URL to extract campaign parameters from (optional, defaults to current URL)
 * @returns {Promise<Object|null>} Conversion data if tracked, null if no campaign found
 */
export const trackConversionHelper = async (purpose, type, url = null) => {
  try {
    const targetUrl = url || window.location.href;
    const campaignParams = extractCampaignParams(targetUrl);
    
    if (campaignParams.cmpg_identifier) {
      const conversionData = {
        cmpg_identifier: campaignParams.cmpg_identifier,
        purpose: purpose,
        type: type,
        referrer: document.referrer ? new URL(document.referrer).hostname : null,
      };
      
      await trackConversion(conversionData);
      return conversionData;
    }
    
    return null; // No campaign found, no tracking
  } catch (error) {
    // Silent error handling - tracking errors don't break the app
    return null;
  }
};

/**
 * Common conversion purposes
 */
export const CONVERSION_PURPOSES = {
  CREATE_ACCOUNT: 'create account',
  CREATE_EXPERT_ACCOUNT: 'Create expert account',
  CREATE_FILING: 'create filing',
  COMPLETE_FILING: 'complete filing',
  PURCHASE: 'purchase',
};

/**
 * Conversion types
 */
export const CONVERSION_TYPES = {
  CLK: 'CLK',
  UNK: 'UNK',
};
